import { FC } from 'react';

import { HeadingContainer } from '../Heading';
import { Listing } from '../Listing';
import { PageLayout } from '../../components/PageLayout';

export const PageContainer: FC = () => {
  return (
    <PageLayout>
      <HeadingContainer />
      <Listing />
    </PageLayout>
  );
};
